import Chip from '@components/Chip/Chip';
import { AnimatePresence, motion } from 'motion/react';

import styles from './ChipSelector.module.scss';

type ChipSelectorProps = {
  onSelect: (id: string) => void;
  size?: 'small' | 'medium';
  color?: 'attention' | 'highlight' | 'subtle';
} & (
  | {
      mode: 'single';
      selectedOption: string | undefined;
      options: string[];
    }
  | {
      mode: 'multi';
      options: { value: string; selected?: boolean }[];
    }
);

const ChipSelector: React.FC<React.PropsWithChildren<ChipSelectorProps>> = (props) => {
  return (
    <ul className={styles['chip-selector']}>
      <AnimatePresence>
        {(props.mode === 'single' || !props.mode) &&
          props.options.map((option, i) => {
            const variant = props.selectedOption === option ? 'filled' : 'outlined';

            return (
              <motion.li
                className={styles['chip-selector-item']}
                // biome-ignore lint/suspicious/noArrayIndexKey: historic
                key={i}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <Chip
                  id={option}
                  aria-label=""
                  onClick={props.onSelect}
                  variant={variant}
                  size={props.size}
                  color={props.color}
                >
                  {option}
                </Chip>
              </motion.li>
            );
          })}

        {props.mode === 'multi' &&
          props.options.map((option, i) => {
            const variant = option.selected ? 'filled' : 'outlined';

            return (
              <motion.li
                className={styles['chip-selector-item']}
                // biome-ignore lint/suspicious/noArrayIndexKey: historic
                key={i}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <Chip
                  id={option.value}
                  aria-label=""
                  onClick={props.onSelect}
                  variant={variant}
                  size={props.size}
                  color={props.color}
                >
                  {option.value}
                </Chip>
              </motion.li>
            );
          })}
      </AnimatePresence>
    </ul>
  );
};

export default ChipSelector;
